import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'pharmNumberformat'
})
export class PharmNumberformatPipe implements PipeTransform {

  transform(value: any, ...any: unknown[]): unknown {
    // console.log(value.substr(3,7));
    // console.log(value.substr(7,value?.length-1));
    return value ? `(${value.substring(0, 3)}) ${value.substring(3, 6)}-${value.substring(6)}`: "";
  }

}
